// app/ningenie/components/ThemeInitializer.tsx
// baby: Initializes theme from localStorage on mount
// Ensures consistent theming across all NinGenie pages
'use client'

// app/ningenie/components/ThemeInitializer.tsx
// baby: Initializes theme from localStorage on mount
// Ensures consistent theming across all NinGenie pages

import { useEffect } from 'react'

export const ThemeInitializer = () => {
  useEffect(() => {
    // baby: Read theme from localStorage and apply to document
    if (typeof window !== 'undefined') {
      const savedTheme = localStorage.getItem('theme')
      
      if (savedTheme === 'dark') {
        document.documentElement.classList.add('dark')
        document.documentElement.classList.remove('light')
      } else if (savedTheme === 'light') {
        document.documentElement.classList.remove('dark')
        document.documentElement.classList.add('light')
      } else {
        // baby: Default to light theme if no preference saved
        document.documentElement.classList.remove('dark')
        document.documentElement.classList.add('light')
      }
    }
  }, [])

  // baby: Also listen for theme changes from other pages/components
  useEffect(() => {
    const handleThemeChange = (event: CustomEvent<{ isDark: boolean }>) => {
      if (event.detail.isDark) {
        document.documentElement.classList.add('dark')
        document.documentElement.classList.remove('light')
      } else {
        document.documentElement.classList.remove('dark')
        document.documentElement.classList.add('light')
      }
    }

    window.addEventListener('themeChange', handleThemeChange as EventListener)
    return () => window.removeEventListener('themeChange', handleThemeChange as EventListener)
  }, [])

  return null
}

